import { useHistory, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useContext, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Context from "../Contex/Context";

export default function GoogleVerify(props) {
  const { status,message } = props.match.params;
  const {setAuthenticate}=useContext(Context);
  const [showToast, setShowToast] = useState(false);
  const history = useHistory();

  useEffect(() => {
    console.log(';fnfnfnfnfndnfdnf',status,message)
    if(status){
      axios
      .post(`${BaseUrl.baseurl}/email-marketing/user/verify-google-user/${message}`)
      .then((res) => {
        if (res.data.status) {
            localStorage.setItem("MailSenderuserDetails",JSON.stringify(res.data))
            setAuthenticate(true)
            history.push('/Email/accounts')
        }
        else
        {
          setShowToast(false)
          history.push('/login')
        }
      })
      .catch((err) => console.log("Error"));
    }
   
  }, []);
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress
        size={60}
        style={{
          color: "#1C485F",
        }}
      />
      {showToast && <ToastContainer />}
    </div>
  );
}
